export const DOCUMENT_VALIDATE = {
  INVALID_DOCUMENT_TYPE: {
    message: 'INVALID_DOCUMENT_TYPE',
    label: 'invalidDocumentType',
    status: 400,
  },
  IDENTIFICATION_ALREADY_EXISTS: {
    message: 'IDENTIFICATION_ALREADY_EXISTS',
    label: 'identificationAlreadyExists',
    status: 442,
  },
  DOCUMENT_TOO_SHORT: {
    message: 'DOCUMENT_TOO_SHORT',
    label: 'documentTooShort',
    status: 400,
  },
  DOCUMENT_TOO_LONG: {
    message: 'DOCUMENT_TOO_LONG',
    label: 'documentTooLong',
    status: 400,
  },
  INVALID_DOCUMENT_FORMAT: {
    message: 'INVALID_DOCUMENT_FORMAT',
    label: 'invalidDocumentFormat',
    status: 400,
  },
  INVALID_AGE_RANGE: {
    message: 'INVALID_AGE_RANGE',
    label: 'invalidAgeRange',
    status: 400,
  },
};


export const ERROR_VALIDATION_TYPES = {
  maxLength: 'maxLength',
  minLength: 'minLength',
  minAge: 'minAge',
  maxAge: 'maxAge',
};

